import { useBranchCircuitStatus, SensorCardStatus } from 'common';
import { useEffect, useState } from 'react';

import { useAppSync } from '../../contexts/AppSyncContext';

export interface ElectricalDeviceStatus {
  status: SensorCardStatus;
  onlineDeviceCount: number;
  offlineDeviceCount: number;
  totalDeviceCount: number;
}

export const useElectricalDeviceStatus = (): ElectricalDeviceStatus => {
  const { selectedHubId } = useAppSync();
  const { branchCircuits } = useBranchCircuitStatus({ selectedHubId });
  const [deviceStatus, setDeviceStatus] = useState<ElectricalDeviceStatus>({
    status: SensorCardStatus.Good,
    onlineDeviceCount: 0,
    offlineDeviceCount: 0,
    totalDeviceCount: 0,
  });

  useEffect(() => {
    const totalDeviceCount = branchCircuits.length;
    const offlineDeviceCount = branchCircuits.filter(
      (circuit) => circuit.status === SensorCardStatus.Error,
    ).length;
    const onlineDeviceCount = totalDeviceCount - offlineDeviceCount;

    const status = offlineDeviceCount > 0 ? SensorCardStatus.Error : SensorCardStatus.Good;

    setDeviceStatus({
      status,
      onlineDeviceCount,
      offlineDeviceCount,
      totalDeviceCount,
    });
  }, [selectedHubId, branchCircuits]);

  return deviceStatus;
};
